module.exports = __webpack_public_path__ + "static/media/takethestage1.a3aa2f9a.jpg";